import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import Routes from './routes';
import 'jquery';
import i18next from 'i18next';
import moment from 'moment';
import 'moment/locale/fr';
import './common/components/UI/FontAwesome/FontAwesome';


// Application Styles
import './common/styles/BS/bootstrap.min.css';
import './common/styles/index.css';
import './common/styles/custom.css';
import './common/styles/app.scss';
import 'tui-calendar/dist/tui-calendar.css';
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import 'nprogress/nprogress.css';
import 'react-redux-spinner/dist/react-redux-spinner.css';

//Local Variables
var $ = require('jquery');
moment.locale(i18next.language)
// Disable warning "Synchronous XMLHttpRequest on the main thread is deprecated.."
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    options.async = true;
});

createRoot(document.getElementById('root')).render(
    (<Router>
        <Routes />
    </Router>)
);
